import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';

import { fieldWrapperStyle, generateMuiTextFieldCustomColorStyle } from 'common/style/fields.style';
import { generateSectionStyle } from 'common/style/cssStyleType';
import useFocus from 'client/components/FormContent/Field/fieldState';
import NameDescription from 'common/components/NameDescription';
import withSettings from 'editor/components/FormContent/Field/withSettings';

function FieldMultiLine({
    fieldId,
    displayName,
    description,
    value,
    error,
    touched,
    handleChange,
    handleBlur,
    settingStyle,
    isRequired
}) {
    const { t } = useTranslation();
    const [focus, toggleError] = useFocus(false);
    const { displayNameStyle, descStyle, answerStyle } = generateSectionStyle(settingStyle);
    const showError = !focus && error && touched;
    return (
        <div css={css(fieldWrapperStyle)} id={`section_${fieldId}`}>
            <NameDescription
                displayName={displayName}
                description={description}
                displayNameStyle={displayNameStyle}
                descStyle={descStyle}
                isRequired={isRequired}
            />
            <TextField
                css={css(generateMuiTextFieldCustomColorStyle(answerStyle))}
                fullWidth
                multiline
                placeholder={t('section.answer.long.placeholder')}
                onFocus={() => toggleError(true)}
                onBlur={e => toggleError(false, handleBlur, e)}
                onChange={handleChange}
                name={String(fieldId)}
                value={value[fieldId]}
                error={showError}
            />
            {showError && (
                <span css={css(errorStyle)} id="feedback">
                    {error}
                </span>
            )}
        </div>
    );
}

FieldMultiLine.propTypes = {
    fieldId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    displayName: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.shape({}),
    error: PropTypes.string,
    touched: PropTypes.bool,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    settingStyle: PropTypes.object,
    isRequired: PropTypes.bool
};

export default withSettings(FieldMultiLine);

const errorStyle = `
    text-align: right;
    font-size: 0.8125rem;
    line-height: 1.1875rem;
    color: #D52027;
    float: right;
`;
